




















































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { Component, Prop } from 'vue-property-decorator';
import { SwTable, TableData, TableColumnConfig, TableEntry } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { CreateElement, VNode } from 'vue';
import ReleaseHelpDialog from './release-help-dialog.component.vue';
import TermsAndConditionsDialog from './terms-and-conditions-dialog.component.vue';
import { envCongif } from '@/shared/env.config';
import { InfoState } from '@/core';
const cssPrefix = 'downloadTable';

@Component({
  components: {
    ...UUIFComponents,
    SwTable,
    SwIconButton,
    SwIcon,
    ReleaseHelpDialog,
    TermsAndConditionsDialog,
  },
})
export default class DownloadsTable extends SwExtendedVue {
  @Prop() softwareList: any[];
  @Prop() title: string;
  @Prop() releaseType: string;
  showReleaseHelp: boolean = false;
  cssPrefix = cssPrefix;
  dwnldObj: any = {};
  baseUrl = `${envCongif.apiGatewayHostUrl}/`;
  showTandCDialog: boolean = false;
  termsandconditionsmessage: any = '';

  get subTableData() : TableData {
    this.softwareList.map((item: any, index: number) => {
      item['_key'] = index + 1;
    });
    return this.softwareList;
  }

  get tableColConfigArr(): TableColumnConfig[] {
    const makeElipsis = (item: string, size = 20) => {
      if (item.length > size) {
        return `${item.slice(0, size)}...`;
      } return item;
    };
    return [
      {
        key: 'name',
        dataKey: 'name',
        title: this.$t('products.name')
        .toString(),
      },
      {
        key: 'version',
        dataKey: 'version',
        title: this.$t('products.version')
        .toString(),
      },
      {
        key: 'releaseDate',
        dataKey: 'releaseDate',
        title: this.$t('products.release_date')
        .toString(),
      },
      {
        key: 'firmwareEndDate',
        dataKey: 'firmwareEndDate',
        sorter: true,
        /* tslint:disable-next-line */
        title: (h: CreateElement): VNode => {
          return (
            <div style="display:flex;align-items:center;">
              <span style="margin-right:1rem;"> { this.$t('downloadcenter.eosDate') } </span>
              <div style="cursor:pointer;">
                {/* tslint:disable-next-line */}
                <SwIcon name="informational" props-size={15} color="#47afe2" v-tooltip={{ content: this.$t('common.eosInfo'), compact: true, placement: 'bottom' }} ></SwIcon>
              </div>
            </div>
          ) as VNode;
        },
        width: 150,
        scalable : true,
        /* tslint:disable-next-line */
        render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
          return (
            <span style={ data.entry.firmwareStatus === 'ACTIVE' ? '' : 'color: red' }> {data.entry.firmwareEndDate} </span>
          ) as VNode;
        },
      },
      {
        key: 'fileSize',
        dataKey: 'fileSize',
        title: this.$t('products.file_size')
        .toString(),
      },
      {
        key: 'instruction',
        dataKey: 'instruction',
        title: this.$t('quote.instructions')
        .toString(),
        // tslint:disable-next-line
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div v-tooltip={{ placement: 'top', persistent: false, compact: true, content: data.entry.instruction }}>
              { makeElipsis(data.entry.instruction, 30) }
            </div>
          ) as VNode;
        },
      },
      {
        key: '',
        dataKey: '',
        title: '',
        // tslint:disable-next-line
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          const result = data.entry;
          let infoContent = '';
          if (result.sha256Hash === '') {
            infoContent = `MD5 ${this.$t('downloadcenter.checksum')
            .toString()}: ${result.md5HashValue}`;
          } else {
            infoContent = `MD5 ${this.$t('downloadcenter.checksum')
            .toString()}: ${result.md5HashValue} <br> SHA256 ${this.$t('downloadcenter.checksum')
            .toString()}: ${result.sha256Hash}`;
          }
          return (
            <div style="display: flex; justify-content: start">
            {<SwIconButton icon="informational" v-tooltip={{
              content: infoContent,
              compact  : true,
              placement: 'top',
            } as TooltipDirValues}
             ></SwIconButton>}
            {<SwIconButton icon="file-text2" nativeOn-click={() => window.open(result.releaseNoteURL, '')}
            v-tooltip={{
              content: this.$t('downloadcenter.releaseNote')
              .toString(),
              compact  : true,
              placement: 'top',
            } as TooltipDirValues}
             ></SwIconButton>}
            {<SwIconButton
              // tslint:disable-next-line
              style={[{ cursor: data.entry.firmwareStatus === 'ACTIVE' ? 'pointer' : 'not-allowed' }]}
              icon="download" nativeOn-click={() => data.entry.firmwareStatus === 'ACTIVE' && this.downloadSoftware(result)}
              v-tooltip={{ content: `${this.$t('products.release_date')} : ${result.fileSize}`, compact: true, placement: 'top' } as TooltipDirValues }
              >
              </SwIconButton>
            }
            {<SwIconButton icon="stats-growth" v-tooltip={{
              content: `${this.$t('common.download')
              .toString()}: ${result.downloadCount}`,
              compact  : true,
              placement: 'top',
            } as TooltipDirValues}
             ></SwIconButton>}
            </div>
          ) as VNode;
        },
      },
      // {
      //   key: 'fileType',
      //   dataKey: 'fileType',
      //   title: 'FILE TYPE',
      // },
    ];
  }

  openReleaseHelp() {
    console.warn('opening true');
    this.showReleaseHelp = true;
  }
  releaseHelpDialog() {
    this.showReleaseHelp = false;
  }

  closeTandCDialog() {
    this.showTandCDialog = false;
  }

  // tslint:disable-next-line
  async downloadSoftware(data:any) {
    const sessionID = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
    const userId = this.$store.getters.getUserId;
    if (!data) {
      return;
    }
    if (data.TNCID.toString() !== '0') {
      if (data.free) {
        this.dwnldObj = {
          username: 'ANONYMOUS',
          swid: data.softwareID.toString(),
          tncid: data.TNCID.toString(),
          isRNotes: data.isRNotes.toString(),
          swgroupid: data.softwareGroupID.toString(),
          sessionid: 'ANONYMOUS',
        };
      } else {
        this.dwnldObj = {
          username: userId,
          swid: data.softwareID.toString(),
          tncid: data.TNCID.toString(),
          isRNotes: data.isRNotes.toString(),
          swgroupid: data.softwareGroupID.toString(),
          sessionid: sessionID,
        };
      }
      this.fetchTermsAndConditions();
      this.showTandCDialog = true;
    } else {
      this.$store.commit('startLoading');
      setTimeout(() => { this.$store.commit('stopLoading'); }, 1000);
      // User or free.
      const payload = { username:'ANONYMOUS', swID:data.softwareID, swGrpID: data.softwareGroupID, isRNotes: data.isRNotes, appName:'MSW', oemCode:'SNWL' };
      if (data.free) {
        payload.username = 'ANONYMOUS';
      } else {
        payload.username = userId;
      }
      this.$store.dispatch(
      'DownloadCenterStoreModule/downloadSoftware', payload,
    )
    .then((resp: any) => {
      if (resp.operationStatus === 'NOK') {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      } else {
        window.open(resp.content.downloadUrl);
      }
    })
    .catch((errorRes: any) => {
      console.error(errorRes.message);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
    }
  }

  fetchTermsAndConditions() {
    const request = {
      username: this.dwnldObj.username || '',
      swID: this.dwnldObj.swid || '',
      tncID: this.dwnldObj.tncid || '',
    };
    this.$store.dispatch('FreeDownloadsStoreModule/getDownloadTC', request)
    .then((resp: any) => {
      if (resp.operationStatus === 'OK') {
        this.termsandconditionsmessage = resp.content.termsNConditions;
        this.termsandconditionsmessage = this.termsandconditionsmessage.replace(/&lt;/g, '<');
        this.termsandconditionsmessage = this.termsandconditionsmessage.replace(/&gt;/g, '>');
        this.termsandconditionsmessage = this.termsandconditionsmessage.replace(/&lt;/g, '/>');
      } else {
        this.showMessage('failed', resp.msgDesc);
      }
    })
    .catch((errresponse:any) => {
      console.error(errresponse);
      this.showMessage('failed', 'Something went wrong');
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

   // For toaster message
  showMessage(infoType: string, infoMsg: string): void {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }
}
